import { render, staticRenderFns } from "./OfficialWechat.vue?vue&type=template&id=d4edb452"
import script from "./OfficialWechat.vue?vue&type=script&lang=js"
export * from "./OfficialWechat.vue?vue&type=script&lang=js"
import style0 from "./OfficialWechat.vue?vue&type=style&index=0&id=d4edb452&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports